<template>
  <el-dialog
      v-el-drag-dialog
      class="adaptationModal"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="文件记录"
      width="1100px"
      @close="close()">
    <Table
        v-loading="contentLoading"
        border
        stripe
        height="700"
        :columns="columns"
        :data="data"/>
    <span slot="footer">
      <el-button @click="close()">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>

  export default {
    name: "",
    data() {
      return {
        dialogVisible: false,
        billId: "0",
        billType: "0",
        // billType: "0",
        columns: [
          {
            title: "文件类型",
            key: "fileTypeName",
            width: 100,
            align: "center",
          },
          {
            title: "文件名称",
            key: "fileName",
            tooltip: true,
            minWidth: 200,
          },
          {
            title: "文件路径",
            key: "filePath",
            tooltip: true,
            minWidth: 200,
            render: (h, params) => {
              return h(
                  "span", {
                    style: {
                      color: "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.download(params.row.filePath);
                      },
                    },
                  },
                  params.row.filePath,
              );
            },
          },
          {
            title: "版本",
            key: "version",
            align: "center",
            width: 80,
          },
          {
            title: "创建人",
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            title: "创建时间",
            key: "createTime",
            width: 180,
            align: "center",
          },
        ],
        data: [],
        contentLoading: false,
      };
    },
    methods: {
      download(filePath) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(filePath)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },

      open(row) {
        this.dialogVisible = true;
        this.data = row.detailVos;
      },
      close() {
        this.dialogVisible = false;
      },
      getData(pkId) {
        this.contentLoading = true;
        this.$http
            .get("basic", `esops/${pkId}`)
            .then((resp) => {
              if (resp.success) {
                this.data = resp.data.detailVos;
              }
              this.contentLoading = false;
            })
            .catch(() => {
              this.contentLoading = false;
            });
      },
    },
  };
</script>
